import { Component } from 'react';
import { observer, inject } from 'mobx-react';

import applicationRouter from '~/hoc/applicationRouter'
import withLocalization from '~/hoc/withLocalization';
import withPermissions from '~/hoc/withPermissions';
import { MembersWidgetMultipleSelectforAll } from '../../../components/GenericForm/Widgets/UsersWidget';
import ConversationSearch from '../ConversationSearch';
import ConversationListItem from '../ConversationListItem';

import addBtn from '../../../assets/img/plus.png'

import './ConversationList.css';

class ConversationList extends Component {
    constructor(props) {
        super(props);
        this.createRoom = this.createRoom.bind(this);
        this.state = {
            rooms: [],
            flag: 1,
            searchText: '',
            name: '',
            roomMembers: null,
            privateRooms: [],
            findChatUsers: []
        }
    }

    componentDidMount() {
        this.setState({
            rooms: this.props.rooms ? this.props.rooms : [],
            privateRooms: this.props.privaterooms ? this.props.privaterooms : [],
        });

    }

    static getDerivedStateFromProps(nextProps, prevState) {
        const { privateRooms } = prevState
        if (prevState.privateRooms != nextProps.privaterooms) {
            let getUpdatedPrivateRooms = nextProps.privaterooms || [];
            return {
                privateRooms: getUpdatedPrivateRooms
            }
        }
        return { privateRooms }
    }

    onSearch(text) {
        const rooms = this.props.rooms ? this.props.rooms : [];
        const filteredRooms = rooms.filter(obj => obj.name.toLowerCase().indexOf(text.toLowerCase()) >= 0);
        this.setState({ rooms: filteredRooms });
    }

    handleTabChange(tabid) {
        this.setState({ flag: tabid }, () => this.setupChatRooms(tabid));
    };

    async setupChatRooms(tabid) {
        const { chatStore } = this.props
        chatStore.setCurrentTab(tabid)
        if (tabid === 2) {
            if (!chatStore.currentPrivateAllRooms)
                await chatStore.loadPrivateRooms();
            this.props.chatStore.setCurrentPrivateRoom(null);
            this.props.chatStore.setCurrentPrivateRoomId(null);
            this.props.router.navigate('/admin/privatechat')
        }
        if (tabid === 1) {
            this.props.router.navigate('/admin/chat')
        }
    }


    handleChange = (value) => {
        this.setState({ roomMembers: value });
    };

    createRoom() {
        const { roomMembers } = this.state;
        const { chatStore, userStore, commonStore, t } = this.props;
        if (roomMembers && roomMembers.split(",").length > 5) {
            return commonStore.addNotification(t('You can select only up to 5 members!'), null, 'error');
        }
        let payload = {
            roomMembers: roomMembers,
            user_id: userStore.currentUser.id,
            client_id: userStore.currentUser.client_id
        }
        chatStore.createPrivateRoom(payload).then(data => {
            if (data) {
                this.props.createPrivateRoom(data);
                this.setState({ roomMembers: null });
            }
        }
        ).catch((error) => {
            commonStore.addNotification('No members selected', null, 'error');
        })

    }

    render() {
        const {
            t, allowModification, currentRoomId, unreads, chatStore, privateUnReads
        } = this.props;
        const { chatCurrentTab, currentPrivateRoomId, currentPrivateRoom } = chatStore;
        const { flag, name } = this.state;

        return (
            <div className="conversation-list">
                <div className="conversation-tab" >
                    <p className={(chatCurrentTab === 1 ? "conversation-list-title-project-active" : "conversation-list-title-project")} onClick={() => this.handleTabChange(1)}>{t('Projects')}</p>
                    <p className={(chatCurrentTab === 2 ? "conversation-list-title-user-active" : "conversation-list-title-user")} onClick={() => this.handleTabChange(2)}>{t('Members')}</p>
                </div>
                {(chatCurrentTab === 1) ?
                    <div>
                        <div className='mt-10 p-1'>
                            <ConversationSearch
                                search={(text) => this.onSearch(text)}
                                rooms={this.props.rooms ? this.props.rooms : []}
                                t={t} />
                        </div>
                        {this.state.rooms.map(room => (
                            <ConversationListItem
                                currentRoomId={currentRoomId}
                                unreads={unreads}
                                key={room.id}
                                data={room}
                                changeRoom={id => this.props.changeRoom(id)}
                                editRoom={id => this.props.editRoom(id)}
                                allowModification={allowModification}
                                t={this.props.t}
                            />
                        ))}
                    </div>
                    :
                    <div>
                        <div className="users-chat mt-4 ms-1">

                            <MembersWidgetMultipleSelectforAll
                                value={name}
                                onChange={value => {
                                    this.handleChange(value);
                                }}
                            />

                            <button
                                onClick={this.createRoom}
                                disabled={this.state.roomMembers === null || this.state.roomMembers === ''}
                                className='createroombutton'
                                style={{ visibility: 'hidden' }}>
                                <img src={addBtn} style={{ visibility: 'visible' }} alt='addbtn' />
                            </button>
                        </div>


                        {this.state.privateRooms.map(room => (
                            <ConversationListItem
                                currentRoomId={currentPrivateRoomId}
                                unreads={privateUnReads}
                                key={room.id}
                                data={room}
                                changeRoom={id => this.props.changePrivateRoom(id)}
                                editRoom={id => this.props.editRoom(id)}
                                allowModification={allowModification}
                                t={this.props.t}
                            />

                        ))}
                    </div>
                }
            </div>
        );
    }
}

export default inject('chatStore', 'userStore', 'commonStore')(withLocalization(withPermissions(applicationRouter(observer(ConversationList)))));
